import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { MenuBar } from "../../components/Menu/Menu";
import { getCurrentMeeting, review, review_no_show } from "../../store/actions/meeting.action";
import { Rating } from "@material-tailwind/react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import MeetingParticipantProfile from "../../components/users/MeetingParticipantProfile";

export default function Review() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [menuOpen, setMenuOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [concerns, setConcerns] = useState("");
  const [stars, setStars] = useState();
  const token = localStorage.getItem("token");
  const mail = localStorage.getItem("mail");
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const navigation = useNavigate();

  useEffect(() => {
    dispatch(getCurrentMeeting({ token, id }));
  }, [dispatch, token, mail, id]);

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const handleNoShowButton = () => {
    dispatch(
      review_no_show({
        token,
        meeting_id: id,
      })
    );
    navigation("/user/meetings");
  };

  const sendReview = () => {
    if (!stars) {
      toast.warn(t("review.choose_rank"), {
        position: "bottom-right",
      });
      return;
    }

    if (comment.length < 10) {
      toast.warn(t("review.comment_too_short"), {
        position: "bottom-right",
      });
      return;
    }

    dispatch(
      review({
        token,
        meeting_id: id,
        stars,
        comment,
        concerns
      })
    );
    navigation("/user/meetings");
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Months are zero-indexed
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <div className="max-w-screen-2xl mx-auto p-4 h-full">
      <Header openMenu={openMenuBar} />
      {/* {currentLeaderUser && currentMeeting && ( */}
      <>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-20 justify-center items-center m-12">
          <div className="flex flex-col items-center mt-28">
            <MeetingParticipantProfile 
              meeting={currentMeeting} 
              t={t} 
              formatDateTime={formatDateTime}
              showMeetingDetails={true}
            />
          </div>
          <div className="flex flex-col items-center mt-28">
            <div className="flex flex-col rounded-[var(--radius)] shadow-lg bg-white w-[400px] h-auto md:w-[600px] lg:w-[700px] md:h-auto p-8">
              <div className="flex flex-col gap-4">
                <p className="text-center text-xl md:text-2xl xl:text-3xl font-semibold text-gray-900">
                  {t("review.write_review")}
                </p>
                <div className="flex flex-col gap-2 items-center">
                  <p className="text-lg font-medium text-gray-900">{t("review.choose_stars")}</p>
                  <Rating
                    unratedColor="amber"
                    ratedColor="amber"
                    value={stars}
                    onChange={(newValue) => setStars(newValue)}
                  />
                </div>
                <div className="flex flex-col mt-2">
                  <label className="text-lg font-semibold text-gray-900 mb-2">
                    {t("review.comment_label") || "Your Review"}
                  </label>
                  <textarea
                    className="w-full h-32 p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-[var(--brand)] resize-none"
                    placeholder={t("review.comment_placeholder") || "Write your review here..."}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                  />
                </div>
                <div className="flex flex-col mt-2">
                  <label className="text-lg font-semibold text-gray-900 mb-2">
                    {t("review.report_label")}
                  </label>
                  <textarea
                    className="w-full h-24 p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-red-400 resize-none"
                    placeholder={t("review.report_placeholder")}
                    value={concerns}
                    onChange={(e) => setConcerns(e.target.value)}
                  />
                </div>
                <div className="flex justify-center mt-4">
                  <button
                    className="bg-[var(--brand)] hover:bg-[var(--brand-dark)] transition-colors w-[180px] h-[45px] md:w-[200px] md:h-[50px] text-lg md:text-xl font-medium text-white rounded-full"
                    onClick={() => {
                      sendReview();
                    }}
                  >
                    {t("review.submit")}
                  </button>
                </div>
              </div>

              <div className="border-t-2 border-gray-200 my-6"></div>

              <div className="flex flex-col gap-4">
                <p className="text-center text-lg md:text-xl font-semibold text-gray-900">
                  {t("review.teacher_no_show_text")}
                </p>
                <div className="flex justify-center">
                  <button
                    className="bg-red-600 hover:bg-red-700 transition-colors w-[180px] h-[45px] md:w-[200px] md:h-[50px] text-lg md:text-xl font-medium text-white rounded-full"
                    onClick={() => {
                      handleNoShowButton();
                    }}
                  >
                    {t("review.no_show")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* )} */}
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
    </div>
  );
}
